export default "__VITE_ASSET__BlEcIgrk__"